import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config';
import { newAWB, RecReasonData } from '../../../services/getDataCall';
import { AWBNumberNormslization } from '../../../services/utility';
import { custom_sort } from '../../../services/utility';
import { getNoOfDaysFromCurrentDate } from '../../../services/DateCalcFuntion';
import { mpsDetails } from '../../../services/mpsDetails';
import { getImgVidProofs } from '../../../services/externalDispute';

export default {
  name: 'investigationactionbyoperation',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      newhubs: '',
      newhublist: [],
      show: false,
      show1: false,
      show2: false,
      //for hun list
      hub: '',
      hublist: [],
      //for status
      Status: '',
      StatusList: [],
      editable:true,
      //verification Status
      vStatus: '',
      vStatusList: [],
      myStr: '',
      todate: '',
      fromdate: '',
      manifestFromDate: '',
      manifestToDate: '',
      investigationStatus: '',
      investigationStatusOptions: [
        { id: 'open', label: 'Open' },
        { id: 'close', label: 'Close' }
      ],
      octroi_MRP: '',
      awbnumber: '',

      listUserData: [],
      accesszonelist: '',
      parsedata: '',
      isLoading1: false,
      pagecount: 1,
      pageno: 0,
      currentPage: 1,
      totalPages: 0,
      Shortagetypelist: [],
      Shortage_type: '',
      showeditmodel: false,
      description: '',

      //table
      tablehublist: [],
      currenthubname: '',
      originhubname: '',
      finaldestinationname: '',

      //client list
      clienList: [],
      hubdroplist: [],
      editshowtable: false,
      operator: '',
      operatorOptions: [
        { id: '1', label: '>' },
        { id: '2', label: '<' },
        { id: '3', label: '=' }
      ],
      exportdis: '',
      List: [],
      abc: '',
      primaryKey: '',
      imgdata: '',
      showModal: false,
      nodata: false,
      ListData: [],
      errormsg: '',
      totalcount: 0,
      pageValue: 0,
      verification: [],
      recreasons: [],
      Awb: [],
      vertical:'',
      verticalList: [{
        id:'1',
        label: 'B2C-Ecom'
      }, {
        id:'2',
        label: 'B2C-Heavies'
      }],
      RECReasonMap: {},
      bulkAWB: [],
      isMpsDetails: false,
      mpsDetailsShipments: [],
      isMpsDetailsLoading: false,
      STDassets : [],
      showSTDModal : false
    }
  },
  mounted() {
    variables.pageRecordLimit = 50;
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.accesszonelist = window.localStorage.getItem('accesszone');
    this.parsedata = JSON.parse(this.accesszonelist);
    this.getzonehubs();
    this.status();
    this.verificationStatusName();
    this.recReasonFetchData()
    if (localStorage.getItem('financepageData') !== null) {
      let pageNum = localStorage.getItem('pageNum');
      let input = JSON.parse(localStorage.getItem('financepageData'));
      localStorage.removeItem('financepageData');
      if (input === undefined) { input = ''; }
      this.getPaginationData(pageNum ? pageNum : 1, input)
      localStorage.removeItem('pageNum')
    }
  },
  destroyed() {
    localStorage.removeItem('financepageData');
  },
  computed: {
    checkDisabled: function () {
      const selectedOperator = this.operator && this.operator.id ? this.operator.id : this.operator;
      return selectedOperator === '' || selectedOperator === null || selectedOperator === undefined;
    },
    ExportDisableds: function () {
      return (this.exportdis == '') ? true : false;
    },

  },
  methods: {
    onFileChange() { },

    getzonehubs() {
      this.show = true;
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getZoneList',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        this.show = false;
        let finalHubData = []
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.hubzoneid,
            label: hub.hubzonename
          })
        })
        this.newhublist = finalHubData
      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    getregionname() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.newhublist.length; i++) {
          if (this.listUserData[j]["hubzoneid"] !== null && this.listUserData[j]["hubzoneid"] != undefined) {

            if (this.newhublist[i]["id"] == this.listUserData[j]["hubzoneid"]) {
              this.listUserData[j]["regionname"] = this.newhublist[i]["label"];

            }
          }
        }

      }

      this.editshowtable = true;
    },

    callHub(newhublist) {
      this.hublist = []

      this.getHubList(newhublist.id)
      this.hub = ''
      if (newhublist.id != undefined) {
        this.getHubList()
      }
    },

    callVstatusList(StatusList) {
      this.vStatusList = []
      this.verificationStatus(StatusList.id);
      this.vStatus = ''
      if (StatusList.id != undefined) {
        this.verificationStatus()
      }


    },
    verificationStatusName() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let vstatusdata = []
        result.data.data.forEach((x) => {
          vstatusdata.push({
            id: x.investigationactionmasterid,
            label: x.actionname
          })
        })
        this.verification = vstatusdata

      },
        error => {

          console.error(error)
        })

    },

    verificationStatus(id) {
      this.input = ({
        investigateshipmentstatusmasterid: id,
        investigationbuckettypeid: 4
      })

      if (id == undefined) {
        this.vStatusList = []
      } else {

        axios({
          method: 'post',
          url: apiUrl.api_url + 'verificationstatus',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(result => {
          let vstatusdata = []
          result.data.data.forEach((x) => {
            vstatusdata.push({
              id: x.investigationactionmasterid,
              label: x.actionname
            })
          })
          this.vStatusList = vstatusdata
        },
          error => {

            console.error(error)
          })
      }
    },

    status() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'status',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {

        let statusdata = []
        result.data.data.forEach((status) => {
          statusdata.push({
            id: status.statuscode,
            label: status.statusname
          })
        })
        this.StatusList = statusdata
      },
        error => {

          console.error(error)
        })
    },

    async ImageView(awb1, status) {
      this.errormsg = ''
      this.abc = awb1;
      let path = '';
      this.primaryKey = 123;
      // console.log(awb1, primary, status);
      // if (status === 17 || status === 13) {
      //   path = `${awsBucketName}/STD/${awb1}`;
      // } else {
      //   path = `${awsBucketName}/${this.primaryKey}${awb1}`;
      // }
      path = `STD/${awb1}`;
      this.input = ({
        key: path,
      });

      if (status == 1 || status == 20) {
        let input = {
          awb : awb1,
          status : status
        }
        const response = await getImgVidProofs(input,this.myStr)
          if (response.data.statusCode !== 100) {
            this.$alertify.error(response.data.msg)
            return;
          }
          const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm'];

          this.STDassets = response.data.data.reduce((acc, item) => {
            let fileExtension = item.key.split('.').pop().toLowerCase();

            if (videoExtensions.includes(fileExtension)) {
              acc.videourl.push({ UnboxingVideoProof1: item.url });
            } else {
              acc.clientImages.push({ attachment: item.url });
            }

            return acc;
          }, { clientImages: [], videourl: [] });
          this.showSTDModal = true;
      }
      else {
        axios({
          method: 'post',
          url: `${apiUrl.api_url
            }getListObjectFroms3`,
          data: this.input,
          headers: {
            Authorization: `Bearer ${this.myStr}`,
          },
        }).then((result) => {
          const images = result.data.data.Contents.sort(custom_sort);
          this.List = images.slice(0, 3);
          if (this.List.length <= 0) {
            this.errormsg = "No Image Found"
          }
        });
      }
    },

    downloadImage(filePath) {
      // this.imgData = filePath;
      this.show1 = true;
      this.input = ({
        key: filePath,
        fileName: 'download.png',
      });

      axios({
        method: 'post',
        url: `${apiUrl.api_url}fetchImages3`,
        data: this.input,
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.show1 = false;
        // console.log('result from fetch api', result);
        const finalImage = result.data.ImageData.Body.data;
        let buff = new Buffer.from(finalImage);
        let base64data = buff.toString('base64');
        this.imgData = 'data:image/png;base64,' + base64data
        // console.log('finalImage: ', toBase64(finalImage));
      });


      this.showModal = true;
    },

    closeImage() {
      this.showModal = false;
    },



    getHubList(id) {


      let finalhublist = []
      for (let i = 0; i < this.parsedata.hubaccess.length; i++) {
        if (id == this.parsedata.hubaccess[i]["HubZoneId"]) {

          finalhublist.push({
            id: this.parsedata.hubaccess[i]["HubID"],
            label: this.parsedata.hubaccess[i]["HubName"]
          })
          this.hublist = finalhublist;

        }
      }


    },
    resetForm() {
      this.pageValue = 0

      this.Status = this.exportdis = this.vStatus = this.hub = this.newhubs = this.awbnumber = this.octroi_MRP =this.vertical= this.fromdate = this.todate = this.manifestFromDate = this.manifestToDate = this.investigationStatus = this.Detented_from = this.Detented_to = ''; this.isLoading1 = this.showSTDModal = false;
      this.$validator.reset(); this.errors.clear();
      this.listUserData = []; this.pageno = 0; this.totalcount = ''; this.pagecount = 1; this.totalRows = '';

    },
    searchUserData() {
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.searchData();
    },
    //to get pagination
    getPaginationData(pageNum, input = '') {
      localStorage.setItem('pageNum', pageNum)
      this.pageValue = pageNum - 1;
      this.pageno = (pageNum - 1) * variables.pageRecordLimit
      this.searchData(this.pageno, input)
    },
    //get client list
    getClientList() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getClientList',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.clienList = result.data.data;




        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.clienList.length; i++) {
            if (this.listUserData[j]["clientid"] !== null && this.listUserData[j]["clientid"] != undefined) {

              if (this.clienList[i]["ClientMasterID"] == this.listUserData[j]["clientid"]) {
                this.listUserData[j]["Clientname"] = this.clienList[i]["CompanyName"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    //dropdown hub
    gethubdropdown() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getHubdropdownlist',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let finalHubData = []
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.HubID,
            label: hub.HubName
          })
        })
        this.hubdroplist = finalHubData;
        this.editshowtable = false;

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["currenthubid"] !== null && this.listUserData[j]["currenthubid"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["currenthubid"]) {
                this.listUserData[j]["currenthubname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["originhubid"] !== null && this.listUserData[j]["originhubid"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["originhubid"]) {
                this.listUserData[j]["originhubname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }
        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j]["finaldestinationid"] !== null && this.listUserData[j]["finaldestinationid"] != undefined) {

              if (this.hubdroplist[i]["id"] == this.listUserData[j]["finaldestinationid"]) {
                this.listUserData[j]["finaldestinationname"] = this.hubdroplist[i]["label"];
              }
            }
          }
        }

        this.editshowtable = true;

      },
        error => {
          console.error(error)
        })
    },
    Statusname() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'statusforstatusnames',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.StatusList2 = result.data.data;
        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.StatusList2.length; i++) {
            if (this.listUserData[j]["status"] !== null && this.listUserData[j]["status"] != undefined) {

              if (this.StatusList2[i]["statuscode"] == this.listUserData[j]["status"]) {
                this.listUserData[j]["Statusname"] = this.StatusList2[i]["statusname"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    buckettypecode() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getinvestigationbuckettype',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.ListData = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.ListData.length; i++) {
            if (this.listUserData[j]["buckettypecode"] !== null && this.listUserData[j]["buckettypecode"] != undefined) {

              if (this.ListData[i]["investigatbuckettypeid"] == this.listUserData[j]["buckettypecode"]) {
                this.listUserData[j]["Buckettypename"] = this.ListData[i]["buckettypename"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    verificationStatusList() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.verification.length; i++) {
          if (this.listUserData[j]["actionstatuscode"] !== null && this.listUserData[j]["actionstatuscode"] != undefined) {

            if (this.verification[i]["id"] == this.listUserData[j]["actionstatuscode"]) {
              this.listUserData[j]["VerificationStatus"] = this.verification[i]["label"];
            }
          }
        }

      }

      this.editshowtable = true;
    },
    NewAwb(data) {
      newAWB(data, this.myStr).then(result => {
        result.data.data.forEach((status) => {
          this.listUserData.forEach((data, i) => {
            if(data.shippingid === status.shippingid){
              this.listUserData[i]["newAWB"] = status.shippingid + 'REC';
              this.listUserData[i]["recreasionname"] = this.Recreasion(status.recreasonid)
            }
          });
        });
      });
    },

    Recreasion(data) {
      let RecReason;
      if(data !== null && data !== undefined){
        RecReason = this.RECReasonMap[data]
      }
      return RecReason;
    },

    recReasonFetchData(){
      RecReasonData(this.myStr).then(result => {
        this.recreasons= result.data.data;
        this.recreasons.map((reasons) => {
          this.RECReasonMap[reasons.recreasonsid] = reasons.recreason
        });
      },
        error => {
          this.show = false;
          console.error(error)
        })
    },
    pendingDays() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {
        if (this.listUserData[j]["financeloggeddate"] !== null && this.listUserData[j]["financeloggeddate"] != undefined) {
          this.listUserData[j]["financependingdays"] = getNoOfDaysFromCurrentDate(moment(new Date(this.listUserData[j]["financeloggeddate"])).format("MM/DD/YYYY"))
        }

      }
      this.editshowtable = true;
    },
    //searchbutton
    searchData(pageNo, input = '') {
      this.awbnumber = AWBNumberNormslization(this.awbnumber).toString();
      this.isLoading1 = true
      this.show2 = true
      this.listUserData = []; this.totalcount = ''; this.pagecount = 1; this.totalRows = '';
      this.exportdis = 1;
      this.totalcount = 0
      const stopSearch = (message) => {
        this.isLoading1 = false;
        this.show2 = false;
        this.$alertify.error(message);
      };
      var formats= /[`!@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?~]/
      if(formats.test(this.awbnumber))
      {
        stopSearch("Please Search Comma Seprated Shippingids")

      }
      else{  
        if (this.vStatus.id) {
         
          var vid = this.vStatus.id;
          var vstatusid = vid.toString();
        }
        if ((this.fromdate && !this.todate) || (!this.fromdate && this.todate)) {
          stopSearch("Please enter both  date")

        }
        else if (this.fromdate > this.todate) {
          stopSearch("From date should not be greater than To date")

        }
        else if ((this.manifestFromDate && !this.manifestToDate) || (!this.manifestFromDate && this.manifestToDate)) {
          stopSearch("Please enter both shipment manifest dates")
        }
        else if (this.manifestFromDate > this.manifestToDate) {
          stopSearch("Shipment manifest from date should not be greater than to date")
        }
        else if ((this.fromdate && this.todate) || (!this.fromdate && !this.todate)) {

          this.input = ({
            offset: pageNo,
            limit: variables.pageRecordLimit,
            shippingid: this.awbnumber,
            FromDate: this.fromdate,
            ToDate: this.todate,
            status: this.Status.id,
            actionstatuscode: vstatusid,
            hubzoneid: this.newhubs.id,
            currenthubid: this.hub.id,
            //originhubid: this.hub.id,
            operator: this.operator && this.operator.id ? this.operator.id : this.operator,
            netvalue: this.octroi_MRP,
            shortagetype: this.Shortage_type.label,
            vertical:this.vertical.id

          })
          if (this.manifestFromDate && this.manifestToDate) {
            this.input.frommanifesteddate = `${this.manifestFromDate.slice(0, 10)} 00:00:00`;
            this.input.tomanifesteddate = `${this.manifestToDate.slice(0, 10)} 23:59:59`;
          }
          const selectedInvestigationStatus =
            this.investigationStatus && this.investigationStatus.id
              ? this.investigationStatus.id
              : this.investigationStatus;
          if (selectedInvestigationStatus) {
            this.input.investigationstatus = selectedInvestigationStatus === 'open';
          }
          this.defaultSearch = Object.assign({}, input ? input : this.input);
          if (input === '') {
            localStorage.setItem('financepageData', JSON.stringify(this.input))
          }

          axios({
            method: 'post',
            url: apiUrl.api_url + 'searchApiProductDamagemarkedbyFinance',
            data: input ? input : this.input,
            headers: {
              'Authorization': 'Bearer ' + this.myStr
            }
          }).then(result => {
            this.show2 = false
            this.listUserData = Array.isArray(result.data.data) ? result.data.data : [];
            this.totalcount = typeof result.data.count === 'number' ? result.data.count : this.listUserData.length
            if (this.totalcount == undefined) {
              this.totalcount = this.listUserData.length
            }
            if (!this.listUserData.length) {
              this.isLoading1 = false;
              this.$alertify.error('No records found for the selected search filters');
            }
            this.NewAwb(this.listUserData);
            this.pendingDays();
            this.getClientList();
            this.gethubdropdown();
            this.getregionname();
            this.Statusname();
            this.buckettypecode();
            this.verificationStatusList()
            this.Recreasion()
            this.getDisputeStatusName(result.data.data);
            for (var i = 0; i < this.listUserData.length; i++) {
              // if (this.listUserData[i].status == 14 || this.listUserData[i].status == 12 || this.listUserData[i].status == 13 || this.listUserData[i].status == 17 || this.listUserData[i].status == 15 || this.listUserData[i].status == 1) {
              //   if (this.listUserData[i].actionstatuscode == 16 || this.listUserData[i].actionstatuscode == 14 || this.listUserData[i].actionstatuscode == null || this.listUserData[i].actionstatuscode == 24 || this.listUserData[i].actionstatuscode == 25 || this.listUserData[i].actionstatuscode == null || this.listUserData[i].actionstatuscode == "") {

                   this.listUserData[i].editable = true;
              //   }
              // } else {
              //   this.listUserData[i].editable = false;
              // }

            }
            if (this.totalcount < variables.pageRecordLimit) {
              this.pagecount = 1
            } else {
              this.pagecount = Math.ceil(this.totalcount / variables.pageRecordLimit)
            }
          }).catch(error => {
            this.isLoading1 = false;
            this.show2 = false;
            console.error(error);
            this.$alertify.error('Failed to fetch data');
          })
        }//else
      }//else
    },
    async getDisputeStatusName(data) {
      let i = 0;
      for (let d of data) {
        if (d.disputestatuscode !== null && d.disputestatuscode !== undefined && d.disputestatuscode !== '' &&
          d.status !== null && d.status !== undefined && d.status !== '') {
          this.input = ({
            Status: d.status,
            DisputeStatusCode: d.disputestatuscode
          });
          let result = await this.getDisputeStatusNameAPICall(this.input);
          this.listUserData[i].disputstatusname = result
        } else {
          this.listUserData[i].disputstatusname = '-'
        }
        i++;
      }
    },

    getDisputeStatusNameAPICall(input) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: apiUrl.api_url + 'DisputeSubStatus',
          data: input,
          headers: {
            'Authorization': 'Bearer ' + this.myStr
          }
        }).then(result => {
          return resolve(result.data.data[0] ? result.data.data[0].pickupstatusname : '-');
        }).catch(err => {
          return reject(err);
        })
      })
    },
    exportfileCSV() {
      const exportPayload = Object.assign({}, this.defaultSearch || this.input || {});
      delete exportPayload.offset;
      delete exportPayload.limit;
      exportPayload.exportdata = true;

      if (!Object.keys(exportPayload).length) {
        this.$alertify.error('Please search data first');
        return;
      }

      this.show2 = true;
      axios({
        method: 'post',
        url: apiUrl.api_url + 'searchApiProductDamagemarkedbyFinance',
        data: exportPayload,
        responseType: 'arraybuffer',
        headers: {
          'Authorization': 'Bearer ' + this.myStr,
          'Content-type': 'application/json'
        }
      }).then((response) => {
        this.show2 = false;

        if (!response.data || response.data.byteLength === 0) {
          this.$alertify.error('No data Found');
          return;
        }

        this.downloadCSV(response.data, `Product_Damage_marked_by_Finance${moment(new Date()).format("YYYY-MM-DD_HH-mm-ss")}.xlsx`);
      }, (error) => {
        this.show2 = false;
        console.error(error);
        this.$alertify.error('Failed to export data');
      });
    },

    downloadCSV(fileData, filename) {
      const blob = new Blob([fileData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", filename || "Product_Damage_marked_by_Finance.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    showMpsDetails(mpsID) {
      // console.log(filePath);
      // this.imgData = filePath;
      this.isMpsDetails = true;
      this.isMpsDetailsLoading = true;
      this.input = ({
        mpsID: mpsID,
      });

      mpsDetails(this.input, this.myStr).then(result => {
        console.log(result);
        this.isMpsDetailsLoading = false;
        this.mpsDetailsShipments = result.data.data;
      })
      


      this.isMpsDetails = true;
    },

    closeMpsDetails(){
      this.isMpsDetails = false;
    },

    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      //columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      //keys = Object.keys(data[0]).slice(0);
      columnDelimiter = "ShippingID,ClientName,OctrioMRP,hubzoneid,HubZoneName,CurrentHubName,OriginHubid,OriginHubName,DestinationHubName,DisputeSatusName,Requestfrom,CreatedBy,OrderType,PhysicalWeight,VolumetricWeight,LoggedDate,LoggedDescription,ColoaderName,BagCondition,Contents,StatusName,VerificationStatus,STDBagCondition,verifieddate,verifieddescription,approvaldate,approvaldescription,lastmodifiedby,ManifestInScanDate,shortagetype,bagno,recreasionname";
      result = "";
      result += columnDelimiter;
      result += lineDelimiter;
      for (let i = 0; i < data.length; i++) {
        result += (data[i].shippingid).toString() + ',' + data[i].Clientname + ',' + data[i].netvalue + ',' + data[i].hubzoneid + ',' + data[i].hubzonename + ',' + data[i].currenthubname + ',' + data[i].originhubid + ',' + data[i].originhubname + ',' + data[i].finaldestinationname + ',' + data[i].disputstatusname + ',' + data[i].Buckettypename + ',' + data[i].createdby + ',' + data[i].ordertype + ',' + data[i].phyweight + ',' + data[i].volweight + ',' + moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].loggeddescription + ',' + data[i].coloaderid + ',' + data[i].stdbagcondition + ',' + data[i].productinformation + ',' + data[i].Statusname + ',' + data[i].VerificationStatus + ',' + data[i].stdbagcondition + ',' + moment(new Date(data[i].verifieddate)).format("DD/MM/YYYY") + ',' + data[i].verifieddescription + ',' + data[i].approvaldate + ',' + data[i].approvaldescription + ',' + data[i].lastmodifiedby + ',' + moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].shortagetype + ',' + data[i].bagno + ',' + data[i].recreasionname;

        result += lineDelimiter;


      }
      return result;
    },
    //new edit model
    neweditpage(shippingid, status, id, currenthubid1) {
      this.$router.push({ path: '/EditProductDamage', query: { shippingid: shippingid, status: status, id: id, currenthubid: currenthubid1 } });
    },
    
    bulkEditPage(){
      if(this.bulkAWB.length >0){
        this.$router.push({ path: '/EditProductDamage', query: {bulk:this.bulkAWB} });
      }else{
        this.$alertify.error("Please select shipments")
      }
    },

    //close edit model
    closeEditModal() {
      this.showeditmodel = false;
    },

    toggle() {
      let checkboxes = document.getElementsByName('chk-shipment');
      let actionCheckbox = document.getElementsByName('actionToggle');
      for(var i=0, n=checkboxes.length;i<n;i++) {
        if(actionCheckbox[0].checked){
          if(!checkboxes[i].checked){
            checkboxes[i].click()
          }
        }else{
          if(checkboxes[i].checked){
            checkboxes[i].click()
          }
        }
        // checkboxes[i].checked = actionCheckbox[0].checked;
        // console.log(JSON.stringify(checkboxes[i].value));
      }
    },
    closeSTDModal(){
      this.showSTDModal = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ProductDamageByFinance/ProductDamageByFinance.component.js